// Doria V5.11.3 — stable FBT relocation only.
// Moves the Fether "Frequently Bought Together" widget once, after it is mounted,
// into Doria's dedicated full-width pairing stage. No polling intervals and no
// changes to product form, variants, Add to Cart or WhatsApp.
(() => {
  const HEADING_RE = /(frequently\s+bought\s+together|bought\s+together|يتم\s+شراؤها\s+معًا|اشتر.*معًا)/i;
  const ACTION_RE = /(buy\s+together|add\s+selected|add\s+all|اشتر.*معًا|أضف.*السلة)/i;

  function findWidgetRoot(heading) {
    if (!heading) return null;

    let node = heading.parentElement;
    let best = null;

    // Stay well inside the product area; never allow product-info/main section
    // itself to become the relocation target.
    for (let depth = 0; node && depth < 7; depth += 1, node = node.parentElement) {
      if (
        node.matches?.('product-info, .product, .product__info-wrapper, main, body, html')
      ) break;

      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      const imageCount = node.querySelectorAll?.('img').length || 0;
      const checkboxCount = node.querySelectorAll?.('input[type="checkbox"]').length || 0;
      const hasAction = ACTION_RE.test(text);

      if (imageCount >= 2 && (checkboxCount >= 1 || hasAction)) {
        best = node;
      }
    }

    return best || heading.parentElement;
  }

  function locateFbt() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return null;

    const headings = productInfo.querySelectorAll('h1,h2,h3,h4,h5,h6,[role="heading"]');
    for (const heading of headings) {
      if (HEADING_RE.test((heading.textContent || '').trim())) {
        return { heading, root: findWidgetRoot(heading) };
      }
    }
    return null;
  }

  function mountFbt() {
    const stage = document.querySelector('.doria-pairing-stage');
    const mount = stage?.querySelector('[data-doria-pairing-mount]');
    if (!stage || !mount || mount.dataset.doriaMounted === 'true') return false;

    const found = locateFbt();
    if (!found?.root) return false;

    // Safety: never move any core product container.
    if (found.root.matches('product-info, .product, .product__info-wrapper')) return false;

    found.heading.classList.add('doria-fbt-original-heading');
    found.root.classList.add('doria-relocated-fbt');
    mount.appendChild(found.root);
    mount.dataset.doriaMounted = 'true';
    stage.hidden = false;
    return true;
  }

  function init() {
    if (mountFbt()) return;

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const observer = new MutationObserver(() => {
      if (mountFbt()) observer.disconnect();
    });

    observer.observe(productInfo, { childList: true, subtree: true });

    // Fether is asynchronous; stop watching after a short bounded window.
    window.setTimeout(() => observer.disconnect(), 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
